import axios from "axios";
import { IllnessModal } from "../../types/illness/IllnessModal";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../axios/axiosInstance";


const apiUrl = process.env.BASE_URL;

interface IllnessState {
  illnessLoading: boolean;
  illnessSuccess: boolean;
  illnessError: any;
  illnesses: IllnessModal[];
}

const initialState: IllnessState = {
  illnessLoading: false,
  illnessSuccess: false,
  illnessError: "",
  illnesses: [],
};

export const getIllness = createAsyncThunk<any>(
  "Illness/getIllness",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`${apiUrl}/illness/all`);
      return response.data.data;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue(
          "An Unknown error occurred while getting Illnesses"
        );
      }
    }
  }
);

const illnessSlice = createSlice({
  name: "Illness", //Slice Name
  initialState,
  reducers: {
    illnessClearSuccess: (state) => {
      state.illnessSuccess = false;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getIllness.pending, (state) => {
        state.illnessLoading = true;
        state.illnessSuccess = false;
        state.illnessError = null;
      })
      .addCase(getIllness.fulfilled, (state, action) => {
        state.illnessLoading = false;
        state.illnessSuccess = true;
        state.illnesses = action.payload;
      })
      .addCase(getIllness.rejected, (state, action) => {
        state.illnessLoading = false;
        state.illnessError = action.payload;
      });
  },
});

export const { illnessClearSuccess } = illnessSlice.actions;
export default illnessSlice.reducer;
